import NapsterSpinner from '@components/NapsterSpinner';

/**
 * Simple loading fallback for Suspense boundaries
 */
export const LoadingFallback = () => (
  <div className="flex items-center justify-center p-4"></div>
);

/**
 * Full page loader for album fetching operations
 */
export const AlbumLoader = () => (
  <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[9999]">
    <div className="flex flex-col items-center">
      <NapsterSpinner size="large" />
    </div>
  </div>
);
